// src/services/adminService.js
import axios from 'axios';
import setUpAxios from '../setUpAxios';
import { baseURL } from '../config';

const CACHE_KEY = 'admin_status_cache';
const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

/**
 * Service to fetch admin status from the server with caching.
 * @returns {Promise<boolean>} true if admin, false otherwise
 */
export const fetchAdminStatus = async () => {
  const cached = localStorage.getItem(CACHE_KEY);

  if (cached) {
    const { value, timestamp } = JSON.parse(cached);
    const now = Date.now();

    if (now - timestamp < CACHE_TTL) {
      return value; // return cached value
    }
  }

  try {
    setUpAxios();
    const response = await axios.get(`${baseURL}/adminAuth`);

    const isAdmin = response.status === 200;

    // Cache the result with timestamp
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ value: isAdmin, timestamp: Date.now() })
    );

    return isAdmin;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};
